import React, { useCallback, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Contact.scss";

import { getPageContent, submitInquiry } from "../../api/apiRequest";
import { NotificationManager } from "react-notifications";
import { useLangContext } from "../../context/languageContext";

import ContactForm from "../../components/ContactForm/ContactForm";
import { Tag } from "../../utils/GTMPageTag";
const Contact = () => {
  Tag("Contact")
  const { hostLanguage } = useLangContext();
  const [contentDetails, setContentDetails] = useState();

  // get page content
  const getAllPageContent = useCallback(async () => {
    try {
      let apiRes = await getPageContent(hostLanguage);
      let responseData = await apiRes.json();
      if (responseData.res) {
        setContentDetails(responseData.data);
        // console.warn(responseData.data);
      } else {
        console.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  },[hostLanguage]);

  // send Inquiry function passed down to ContactForm
  const sendInquiry = async (values, { resetForm }) => {
    try {
      let data_values = {
        companyname: values.companyname,
        name: values.name,
        email: values.email,
        phonenumber: values.phonenumber,
        message: values.message,
      };

      let apiRes = await submitInquiry(data_values);
      let responseData = await apiRes.json();
      if (responseData.res) {
        resetForm({ values: "" });
        NotificationManager.success(responseData.msg, "", 2000);
      } else {
        NotificationManager.error(responseData.msg, "", 2000);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAllPageContent();
  }, [getAllPageContent]);

  return (
    <div className="MainbBody">
      <div className="ContactBannerScetion">
        {/* <h5>In Kontakt treten</h5> */}
        <h5>{contentDetails?.contact_us_page_data?.contact}</h5>
      </div>
      <div className="ContactFrmScetion">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col sm={8}>
              {contentDetails && (
                <ContactForm
                  contentDetails={contentDetails}
                  hostLanguage={hostLanguage}
                  onSubmit={sendInquiry}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Contact;
